import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";
import EDEStatementsEnrollmentProfilePage from "components/EDEStatements/pages/EDEStatementsEnrollmentProfilePage";

/**
 * @name CaptureEDEStatementsEnrollmentSelectProfile
 * @returns {React.Component}
 * @description A capture in the "EDE eStatement Enrollment" capture group.
 */
export default function CaptureEDEStatementsEnrollmentSelectProfile(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    return <EDEStatementsEnrollmentProfilePage />
}